














import { Component, Prop, Vue } from 'vue-property-decorator'
import { getBoUrl } from '@/api/http-constants'

@Component
export default class blocGauche extends Vue {
    @Prop() imagePath: string
    @Prop()
    name: string
    @Prop() content: string

    get image(): string {

        let currentDateWithFormat = new Date().toJSON().slice(0,10).replace(/-/g,'/');
        console.log(currentDateWithFormat);

        return `${getBoUrl()}${this.imagePath}`+'?v='+currentDateWithFormat
    }
}
